import axios from '@/user/axios'

const moduleUserAccounts = {
  namespaced: true,
  state: {
    userAccounts: {}
  },
  getters: {},
  mutations: {
    SET_USER_ACCOUNTS (state, data) {
      state.userAccounts = data
    }
  },
  actions: {
    getUserAccounts (context) {
      return new Promise(async (resolve, reject) => {
        const userId = context.rootState.auth.activeUserId
        const accountId = context.rootState.account.activeAccount.id
        axios.get(`/api/user-accounts/${accountId}/${userId}`)
          .then(resp => {
            context.commit('SET_USER_ACCOUNTS', resp.data.data)
            resolve(resp)
          }).catch(err => {
            reject(err)
          })
      })
    },
    updateUserAccounts (context, payload) {
      return new Promise(async (resolve, reject) => {
        const userId = context.rootState.auth.activeUserId
        const accountId = context.rootState.account.activeAccount.id
        axios.post(`/api/user-accounts/${accountId}/${userId}`, payload)
          .then(resp => {
            context.commit('SET_USER_ACCOUNTS', resp.data.data)
            resolve(resp)
          }).catch(err => {
            reject(err)
          })
      })
    },
    addUserAccounts (context, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axios.post('/api/user-accounts/', payload)
          resolve(res)
        } catch (err) {
          reject(err)
        }
      })
    },
    addUserEmail (context, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axios.post('/api/user-accounts/email/', payload)
          resolve(res)
        } catch (err) {
          reject(err)
        }
      })
    }
  }
}

export default moduleUserAccounts
